import { createApp } from 'vue';
import { createStore } from 'vuex';
import slide from './modules/slide';
import formAskfeedback from './modules/form-askfeedback';
import formGuidedSearch from './modules/form-guided-search';

const debug = process.env.NODE_ENV !== 'production';

const store = createStore({
  modules: {
    slide,
    formAskfeedback,
    formGuidedSearch,
  },
  strict: debug,
});

const app = createApp({});
app.use(store);
app.config.devtools = true;

export default store;
